<template>
	<!-- functionality may be added to this down the line -->
	<div class="modal-header"> <slot/> </div>
</template>

<script>
export default {
	props: {
		inRoot: Boolean
	}
}
</script>

<style lang="scss" scoped>
.modal {
	&-header {
		padding-bottom: 20px;
		padding-right: 30px;
		font-weight: bold;
		font-size: 1.5rem;
		line-height: 1;
	}
}
</style>